const ListingActivationConstants = {
    ERROR_CODE: {
        INVALID_FIELDS: 'listingActivationInvalidFields',
        LISTING_ACTIVATION_BLOCKED: 'listingActivationBlocked',
    },
};

export default ListingActivationConstants;
